<template>
  <div>
    <a role="button" class="btn btn-primary" @click="backToQuestion()">回題目編輯</a>
    <br>
    <a role="button" class="btn btn-primary" @click="submit()"><i class="fas fa-save"></i></a>


    <a class="btn btn-primary" @click="DataItemMaster_AddLast"><i class="fas fa-plus-circle"></i></a>
    <table class="table table-hover" id="tblMain">
      <thead class="thead-light">
      <tr>
        <th class="text-center">功能</th>
        <!--        <th>啟停用</th>-->
        <th>題目</th>
      </tr>
      </thead>
      <tbody>
      <template v-for="(masterItem) in datas.Answers">
        <tr :key="masterItem.systemId">
          <td class="text-center" width="280px">
            <a class="btn btn-primary" @click="DataItemMaster_Insert(masterItem)"><i class="fas fa-plus-circle"></i></a>
            <a class="btn btn-danger" @click="DataItemMaster_Remove(masterItem)"><i class="far fa-trash-alt"></i></a>
            <a class="btn btn-primary" @click="DataItemMaster_MoveUp(masterItem)"><i class="fa fa-angle-up"></i> </a>
            <a class="btn btn-primary" @click="DataItemMaster_MoveDown(masterItem)"><i class="fa fa-angle-down"></i> </a>
            <!--            <a class="btn btn-primary" v-b-toggle="'collapse-' + masterItem.systemId.substr(0,4)" ><i class="fa fa-bars"></i> </a>-->
          </td>
          <!--          <td width="100px" >-->
          <!--            <MyButtonEnableDisable v-model="masterItem.IsEnable"></MyButtonEnableDisable>-->
          <!--          </td>-->
          <td width="" class="">
            <!--            flex-fill-->
            <div class="form-inline">
              <input type="text" class="form-control flex-fill" placeholder="" v-model="masterItem.answer">

              <a role="button" v-if="haveHtmlContent(masterItem)" class="btn btn-primary " @click="editHtmlContent(masterItem)"><i class="fa fa-pen"></i></a>
              <a role="button" v-if="!haveHtmlContent(masterItem)" class="btn btn-secondary " @click="editHtmlContent(masterItem)"><i class="fa fa-pen"></i></a>

<!--              <MyCodeListSelect v-model="masterItem.answerType" :options="$u.TzsciCode_AnswerSelectType" size="md"></MyCodeListSelect>-->
            </div>
            <div class="form-inline">
              評級:
              <select class="form-control" v-model="masterItem.score">
                <option></option>
                <option value="4">重度風險</option>
                <option value="3">高度風險</option>
                <option value="2">中度風險</option>
                <option value="1">低度風險</option>
              </select>
              行動傷友:<input type="text" class="form-control flex-fill" placeholder="" v-model="masterItem.actionForPatient">
              行動個管師:<input type="text" class="form-control flex-fill" placeholder="" v-model="masterItem.actionForCaseMag">
            </div>
          </td>
        </tr>
        <tr :key="'tr'+masterItem.systemId" >
          <td colspan="5">
            <b-collapse :id="'collapse-'+masterItem.systemId.substr(0,4)"  class="mt-2" style="margin-left: 200px">
              <b-card>
                <!--                <b-card-text>答案</b-card-text>-->
                <div class="form-inline">

                  <a role="button"  class="btn btn-primary " @click="editHtmlContent(masterItem)"><i class="fa fa-pen"></i></a>
                </div>

                <!--                <MyCodeListButtonRadio v-model="masterItem.SelectType" :options="$u.TzsciCode_AnswerSelectType" size="md"></MyCodeListButtonRadio>-->
                <!--                <div>-->
                <!--                  <a class="btn btn-primary" @click="DataItemDetail_AddLast(masterItem)"><i class="fas fa-plus-circle"></i></a>-->
                <!--                  <table class="table table-hover" id="tblDetail">-->
                <!--                    <thead class="thead-light">-->
                <!--                    <tr>-->
                <!--&lt;!&ndash;                      <th class="text-center" width="280px">功能</th>&ndash;&gt;-->
                <!--&lt;!&ndash;                      <th>啟停用</th>&ndash;&gt;-->
                <!--                      <th>答案</th>-->
                <!--                      <th>分數</th>-->
                <!--                      <th>行動</th>-->
                <!--                    </tr>-->
                <!--                    </thead>-->
                <!--                    <tbody>-->
                <!--                    <tr v-for="(detailItem,index) in masterItem.Answers" :key="index">-->
                <!--&lt;!&ndash;                      <td class="text-center">&ndash;&gt;-->
                <!--&lt;!&ndash;                        <a class="btn btn-primary" @click="DataItemDetail_Insert(masterItem,detailItem)"><i class="fas fa-plus-circle"></i></a>&ndash;&gt;-->
                <!--&lt;!&ndash;                        <a class="btn btn-danger" @click="DataItemDetail_Remove(masterItem,detailItem)"><i class="far fa-trash-alt"></i></a>&ndash;&gt;-->
                <!--&lt;!&ndash;                        <a class="btn btn-primary" @click="DataItemDetail_MoveUp(masterItem,detailItem)"><i class="fa fa-angle-up"></i> </a>&ndash;&gt;-->
                <!--&lt;!&ndash;                        <a class="btn btn-primary" @click="DataItemDetail_MoveDown(masterItem,detailItem)"><i class="fa fa-angle-down"></i> </a>&ndash;&gt;-->
                <!--&lt;!&ndash;                      </td>&ndash;&gt;-->
                <!--&lt;!&ndash;                      <td width="100px" >&ndash;&gt;-->
                <!--&lt;!&ndash;                        <MyButtonEnableDisable v-model="detailItem.IsEnable"></MyButtonEnableDisable>&ndash;&gt;-->
                <!--&lt;!&ndash;                      </td>&ndash;&gt;-->
                <!--                      <td width="">-->
                <!--                        <div class="form-inline">-->
                <!--                          {{detailItem.Text}}-->
                <!--&lt;!&ndash;                          <input type="text" class="form-control flex-fill" placeholder="" v-model="detailItem.Text">&ndash;&gt;-->
                <!--&lt;!&ndash;                          <a role="button" class="btn btn-primary" @click="editHtmlContent(detailItem)"><i class="fa fa-pen"></i></a>&ndash;&gt;-->
                <!--                        </div>-->
                <!--                      </td>-->
                <!--                      <td width="100px">-->
                <!--                        {{detailItem.Score}}-->
                <!--&lt;!&ndash;                        <input type="number" class="form-control" placeholder="" v-model="detailItem.Score">&ndash;&gt;-->
                <!--                      </td>-->
                <!--                      <td width="200px">-->
                <!--                        {{detailItem.Action}}-->
                <!--&lt;!&ndash;                        <textarea class="form-control" rows="2" v-model="detailItem.Action"></textarea>&ndash;&gt;-->
                <!--                      </td>-->

                <!--                    </tr>-->

                <!--                    </tbody>-->
                <!--                  </table>-->
                <!--                </div>-->
                <!--                <b-button v-b-toggle.collapse-1-inner size="sm">輔助說明</b-button>-->
                <!--                <b-collapse id="collapse-1-inner" class="mt-2">-->
                <!--                  <b-card>xxxxxxxx</b-card>-->
                <!--                </b-collapse>-->
              </b-card>
            </b-collapse>
          </td>

        </tr>
      </template>

      </tbody>
    </table>

    <DLGEditor ref="dlgEditor" v-on:returnOk="dlgEditorReturnOK" />
  </div>


</template>


<script>
/**

 **/

import arrayUtil from "../../util/arrayUtil";
import util from "../../util/util";
import MyButtonEnableDisable from "@/views/taylorAdmin/component/MyButtonEnableDisable";
import MyCodeListSelect from "@/views/taylorAdmin/component/MyCodeListSelect";
import _ from "lodash";
import DLGEditor from "@/views/tzsci/component/DLGEditor";
import apiTzsci from "@/views/tzsci/js/apiTzsci";
import {TZAnswer} from "@/views/tzsci/vo/tzVo";

export default {
  components: {DLGEditor, MyCodeListSelect, MyButtonEnableDisable},
  //name: "contentEdit",
  // props: [""],
  data: function () {
    return {
      id: "",
      questionSystemId:"",
      dataReady: false,
      formData: {
        name: "",
      },
      isEnableFilter: false,
      currentFilterGroup1:"",
      currentFilterGroup2:"",
      datas:{
        /** @type {TZAnswer[]} */
        Answers: [
        ]
      },
    };
  },
  methods: {
    loadData() {
      let that=this;
      let loader=util.ShowLoading(this);
      //
      apiTzsci.api_Admin_Answer_Query(this.questionSystemId).then((data)=>{
        let dataApi=data.data.data;

        that.datas.Answers=dataApi;
        util.HideLoading(loader);
      })
    },
    backToQuestion(){
      this.$router.push({ name: 'AppContentQuestionList'})
    },
    submit(){
      let that=this;
      apiTzsci.api_Admin_Answer_Save(this.questionSystemId, this.datas.Answers).then((data)=>{
        alert('儲存成功')
      })
    },

    DataItemMaster_MoveUp(item) {
      arrayUtil.orderMove(false, item.systemId, this.datas.Answers, "systemId", "seq")
    },
    DataItemMaster_MoveDown(item) {
      arrayUtil.orderMove(true, item.systemId, this.datas.Answers, "systemId", "seq")
    },
    DataItemMaster_AddLast() {
      let newItem = new TZAnswer();
      newItem.systemId = util.uuid();

      arrayUtil.orderAppendLast(newItem, this.datas.Answers, "seq")
    },

    DataItemMaster_Insert(currentItem){
      let newItem = new TZAnswer();
      newItem.systemId = util.uuid();

      arrayUtil.orderInsert(newItem,currentItem,this.datas.Answers,"systemId","seq")
    },

    DataItemMaster_Remove(item) {
      arrayUtil.removeByPredicate(this.datas.Answers,s => s.systemId===item.systemId);
    },

    btnEnableOrDisable(){
      this.isEnableFilter=!this.isEnableFilter;
      if (this.isEnableFilter){
        console.log("");
      }else{
        this.currentFilterGroup1="";
        this.currentFilterGroup2="";
      }
    },
    editHtmlContent(item){
      this.$refs.dlgEditor.callbackItem=item;
      this.$refs.dlgEditor.htmlContent=item.answerDesc;
      this.$refs.dlgEditor.showModal();
    },
    haveHtmlContent(item){
      if (item.answerDesc ){
        return true;
        // if (item.questionDesc.trim() !=="" && item.questionDesc.trim() !=="''"){
        //   return true;
        // }else{
        //   return false;
        // }
      }else{
        return false;
      }
    },
    dlgEditorReturnOK(item){
      item.answerDesc=this.$refs.dlgEditor.htmlContent;
    }
  },
  mounted() {
    this.loadData()
  },
  created() {
    this.questionSystemId= this.$route.query.questionSystemId;
  }
}
</script>


<style scoped>
#tblMain{
  width: 1300px;
}
.thisBtnEdit{
  color: white !important;
  margin: 5px;
  width: 40px;
}
.abutton{
  color: white !important;
}
.filterItembutton{
  color: white !important;
  width: 220px;
}
.btn{
  color: white !important;
  margin: 5px;
}
</style>
